import templateStr from 'text!./templates/ho-select-with-other.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            model: '=',
            otherModel: '=',
            label: '@'
        },
        controller: ['$scope', function ($scope) {
            $scope.isOther = function (v) {
                return v && v.code.toLowerCase() === 'other';
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/directives/HOSelectWithOther.js
// module id = 2156
// module chunks = 0